import { memo } from 'react'
import { MessagePopup } from '@renderforest/rf-components'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

interface IProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

// One-time "Confirm voice ownership" consent, shown before the first
// voice-clone upload.
const ConsentPopup: React.FC<IProps> = ({ isOpen, onConfirm, onCancel }) => (
  <MessagePopup
    isOpen={isOpen}
    type="info"
    title={translate(T.CONFIRM_VOICE_OWNERSHIP_TITLE)}
    message={translate(T.CONFIRM_VOICE_OWNERSHIP_DESCRIPTION)}
    primaryAction={{
      label: translate(T.CONFIRM_LABEL),
      onClick: onConfirm
    }}
    secondaryAction={{
      label: translate(T.CANCEL_LABEL),
      onClick: onCancel
    }}
    onClose={onCancel}
  />
)

export default memo(ConsentPopup)
